export default "__VITE_ASSET__CSNKwvWT__"